import React, { FC } from "react";

import {
  useFooters,
  useBoolean,
  useCounter,
  useApisMembersKnowledgeInsightPostCommentsLikesCreate,
  useApisMembersKnowledgeInsightPostCommentsLikesDestroy,
} from "~/hooks";

import {
  PostHeader,
  PostContent,
  KnowledgeInsightPostCommentsLikedEmployeesModal,
} from "~/components/organisms";

import {
  KnowledgeInsightPostCommentType,
  PostDetailMenuItemType,
} from "~/domains";

import { PostDetailWrapper } from "~/ui";

type PropsType = {
  isHighlight?: boolean;
  knowledgeInsightPostComment: KnowledgeInsightPostCommentType;
  menuItems: PostDetailMenuItemType[];
};

export const KnowledgeInsightPostCommentDetail: FC<PropsType> = ({
  knowledgeInsightPostComment,
  menuItems,
  isHighlight = false,
}: PropsType) => {
  const {
    isChecked: isLikedEmployeesModalOpen,
    setTrue: setLikedEmployeesModalOpen,
    setFalse: setLikedEmployeesModalClose,
  } = useBoolean(false);
  const {
    isChecked: liked,
    setTrue: setLiked,
    setFalse: setNotLiked,
  } = useBoolean(knowledgeInsightPostComment.liked);
  const {
    count: likeCount,
    increment: likeIncrement,
    decrement: likeDecrement,
  } = useCounter(knowledgeInsightPostComment.likesCount);

  const { mutate: likeCreateRequest } =
    useApisMembersKnowledgeInsightPostCommentsLikesCreate();
  const { mutate: likeDeleteRequest } =
    useApisMembersKnowledgeInsightPostCommentsLikesDestroy();

  const handleCreateLike = () => {
    likeCreateRequest(
      {
        knowledgeInsightPostCommentId: knowledgeInsightPostComment.id,
      },
      {
        onSuccess: () => {
          setLiked();
          likeIncrement();
        },
      },
    );
  };

  const handleDeleteLike = () => {
    likeDeleteRequest(
      {
        knowledgeInsightPostCommentId: knowledgeInsightPostComment.id,
      },
      {
        onSuccess: () => {
          setNotLiked();
          likeDecrement();
        },
      },
    );
  };

  const leftFooters = useFooters({
    like: {
      doneAlready: liked,
      undoOnClick: handleDeleteLike,
      doOnClick: handleCreateLike,
      textOnClick: setLikedEmployeesModalOpen,
      count: likeCount,
    },
  });

  return (
    <PostDetailWrapper isHighlight={isHighlight}>
      <PostHeader
        miniText={knowledgeInsightPostComment.createdAt}
        postedEmployee={knowledgeInsightPostComment.employee}
        menuItems={menuItems}
      />
      <PostContent
        content={knowledgeInsightPostComment.content}
        images={knowledgeInsightPostComment.attachFiles}
        footers={leftFooters.footers}
        className="mt-2 pl-16"
        blockQuote={
          knowledgeInsightPostComment.knowledgeInsightPostCommentQuotePost
            ? {
                content:
                  knowledgeInsightPostComment
                    .knowledgeInsightPostCommentQuotePost.content,
                employee:
                  knowledgeInsightPostComment
                    .knowledgeInsightPostCommentQuotePost.employee,
                files:
                  knowledgeInsightPostComment
                    .knowledgeInsightPostCommentQuotePost.attachFiles,
                createdAt:
                  knowledgeInsightPostComment
                    .knowledgeInsightPostCommentQuotePost.createdAt,
              }
            : undefined
        }
      />
      {isLikedEmployeesModalOpen && (
        <KnowledgeInsightPostCommentsLikedEmployeesModal
          onClose={setLikedEmployeesModalClose}
          knowledgeInsightPostCommentId={knowledgeInsightPostComment.id}
        />
      )}
    </PostDetailWrapper>
  );
};
